import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function ProblemIdentification() {
  const items = ['Cada mañana necesitas varios minutos antes de poder moverte con normalidad', 'Subes las escaleras con cuidado porque las rodillas crujen o duelen', 'Has probado suplementos de glucosamina, colágeno y condroitina sin resultados duraderos', 'Tu médico te dice "es normal para tu edad" pero algo dentro de ti sabe que no debería ser así', 'El frío y la humedad empeoran el dolor de forma predecible', 'Sientes que tu cuerpo ya no te responde como antes', 'Has dependido del ibuprofeno o el acetaminofén más de lo que te gustaría admitir'];
  return <section className="bg-cream py-14 px-6 md:px-12 lg:px-24" data-id="element-153">
      <div className="max-w-4xl mx-auto" data-id="element-154">
        {/* CTA Button */}
        <FadeIn data-id="element-155">
          <div className="text-center mb-10" data-id="element-156">
            <a href="#comprar" className="inline-block bg-sage hover:bg-dark-green text-white text-xl md:text-2xl font-bold py-5 px-10 rounded-full shadow-xl transform transition-all duration-300 hover:scale-105 hover:shadow-2xl no-underline" data-id="element-157">
              👆 QUIERO EL PROTOCOLO POR $7
            </a>
            <p className="text-lg text-text-gray font-medium mt-4" data-id="element-158">
              Precio especial por hoy:{' '}
              <span className="text-dark-green font-bold" data-id="element-159">$7</span>
            </p>
          </div>
        </FadeIn>

        <FadeIn data-id="element-160">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-text-black mb-12" data-id="element-161">
            ¿Te identificas con alguna de estas situaciones?
          </h2>
        </FadeIn>

        <div className="space-y-6 mb-12" data-id="element-162">
          {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-163">
              <div className="flex items-start gap-4 bg-white p-6 rounded-xl shadow-sm border border-gold-light" data-id="element-164">
                <CheckCircle2 className="text-sage flex-shrink-0 mt-1" size={28} data-id="element-165" />
                <p className="text-lg md:text-xl text-text-black" data-id="element-166">{item}</p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.8} data-id="element-167">
          <div className="bg-dark-green text-white p-8 rounded-xl text-center shadow-md" data-id="element-168">
            <p className="text-xl md:text-2xl font-serif font-medium" data-id="element-169">
              Si marcaste 3 o más: no estás envejeciendo mal. Tienes un fuego
              interior activo que nadie te ha explicado cómo apagar.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}